import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import React from 'react'
import ReactDOM from 'react-dom'
// import { createBrowserHistory } from 'history'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import 'assets/scss/material-kit-react.scss'

// pages for this product
// import Components from 'views/Components/Components.js'
// import LandingPage from 'views/LandingPage/LandingPage.js'
// import ProfilePage from 'views/ProfilePage/ProfilePage.js'
// import LoginPage from 'views/LoginPage/LoginPage.js'

import IndexPage from 'views/IndexPage/IndexPage'
import CompanyPage from 'views/CompanyPage/CompanyPage.js'
import ServicePage from 'views/ServicePage/ServicePage.js'
import CasePage from 'views/CasePage/CasePage.js'
import CulturePage from 'views/CulturePage/CulturePage.js'
import ContactPage from 'views/ContactPage/ContactPage.js'
import NotFoundPage from 'views/NotFoundPage/NotFoundPage.js'
import PrivacyPage from 'views/PrivacyPage/PrivacyPage.js'

// const beforeRouter = (nextState, replace) => {
//   console.log('beforeRouter', nextState, replace)
// }

// const afterRouter = (nextState, replace) => {
//   console.log('afterRouter', nextState, replace)
// }

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={IndexPage} />
      {/* 公司概况 */}
      <Route path="/company" component={CompanyPage} />
      {/* 服务类型 */}
      <Route path="/service" component={ServicePage} />
      {/* 典型案例 */}
      <Route path="/case" component={CasePage} />
      {/* 企业文化 */}
      <Route path="/culture" component={CulturePage} />
      {/* 联系我们 */}
      <Route path="/contact" component={ContactPage} />
      {/* 隐私政策 */}
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root'),
)
